import { ONBOARDING_PARTICIPANT_ROLES } from "../../../../../../../shared/config";

export const getRoleTextIdVariantByParticipant = (participantRole) => {
  switch (participantRole) {
    case ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER:
      return "CO_BORROWER";
    case ONBOARDING_PARTICIPANT_ROLES.GUARANTOR:
      return "GUARANTOR";
    default:
      return "CO_BORROWER";
  }
};
